module.exports = __webpack_public_path__ + "assets/img/adapter-small.ae9d91e3.png";